import equal from 'fast-deep-equal';

const getPagesToUpdate = (initialPages, currentPages) => {
  const initialPagesMap = {};
  initialPages.forEach(({ html, htmlCheckpoint, ...page }) => {
    initialPagesMap[page.id] = page;
  });

  return currentPages
    .map(({ html, htmlCheckpoint, ...page }) => page)
    .filter((page) => {
      const initialPage = initialPagesMap[page.id];
      if (!initialPage) {
        return false;
      }
      return !equal(page, initialPagesMap[page.id]);
    });
};

export default getPagesToUpdate;
